import React, { useState } from 'react';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { ShareLinkFieldType } from '../link-config-form.factory';

interface Props {
  conversation: ShareLinkFieldType<boolean>;
  onFieldChange: <T>(payload: ShareLinkFieldType<T>) => void;
}

export const ShareConversations = ({ conversation, onFieldChange }: Props) => {
  const [conversationEnabled, setConversationEnabled] = useState(conversation.value);

  const onConversationFieldToggleChanged = (value: boolean) => {
    setConversationEnabled(value);
    onFieldChange({ field: conversation.field, value });
  };

  return (
    <div className='flex flex-col space-y-sm'>
      <ToggleComponent
        checked={conversationEnabled}
        onChange={onConversationFieldToggleChanged}
        label='Allow conversations'
        labelType='strong'
      />
      <div className='text-bedrock-p-small text-bedrock-black'>Allow recipients to leave comments</div>
    </div>
  );
};
